import { BASE_URL, FEATURE_SETTINGS_ENDPOINT, SOMS_API_KEY } from "services/CONSTANTS";
import { UPDATE_SELECTED_MAX_CAP_FAILURE, UPDATE_SELECTED_MAX_CAP_REQUEST, UPDATE_SELECTED_MAX_CAP_RESET, UPDATE_SELECTED_MAX_CAP_SUCCESS } from "./action-type";
import { Patch } from "services/apiService";

export const updateSelectedMaxCapAction = (payload) => {
    return (dispatch) => {
        dispatch(updateSelectedMaxCapRequest());
        const apiUrl = `${BASE_URL}${FEATURE_SETTINGS_ENDPOINT}?apikey=${SOMS_API_KEY}`;
        const request = {
            url: apiUrl,
            params: payload,
        };
        Patch(request)
            .then((response) => {
                if (response.status === 200 || response.status === 204) {
                    dispatch(updateSelectedMaxCapSuccess(response));
                } else {
                    dispatch(updateSelectedMaxCapFailure(response));
                }
            })
            .catch((err) => {
                dispatch(updateSelectedMaxCapFailure(err));
            });
    };
};

const updateSelectedMaxCapRequest = () => ({
    type: UPDATE_SELECTED_MAX_CAP_REQUEST,
});

const updateSelectedMaxCapSuccess = (response) => ({
    type: UPDATE_SELECTED_MAX_CAP_SUCCESS,
    updateSelectedMaxCapResponse: response,
});

const updateSelectedMaxCapFailure = (error) => ({
    type: UPDATE_SELECTED_MAX_CAP_FAILURE,
    updateSelectedMaxCapResponse: error,
});

export const updateSelectedMaxCapReset = () => ({
    type: UPDATE_SELECTED_MAX_CAP_RESET,
});
